export const registrationConstants = {
    NEW_CUSTOMER_REQUEST: 'NEW_CUSTOMER_REQUEST',
    NEW_EXISTING_CUSTOMER_REQUEST: 'NEW_EXISTING_CUSTOMER_REQUEST',
    NEW_CUSTOMER_GET_STARTED_REQUEST: 'NEW_CUSTOMER_GET_STARTED_REQUEST',
    NEW_EXISTING_CUSTOMER_ERROR: "NEW_EXISTING_CUSTOMER_ERROR",

    GET_STARTED_INFORMATION_REQUEST: "GET_STARTED_INFORMATION_REQUEST",
    GET_STARTED_INFORMATION_FAILURE: "GET_STARTED_INFORMATION_FAILURE",

    PERSONAL_INFORMATION_REQUEST: "PERSONAL_INFORMATION_REQUEST",
    PERSONAL_INFORMATION_FAILURE: "PERSONAL_INFORMATION_FAILURE",

    PERSONAL_INFORMATION_BACK_REQUEST: "PERSONAL_INFORMATION_BACK_REQUEST",
    PERSONAL_INFORMATION_BACK_FAILURE: "PERSONAL_INFORMATION_BACK_FAILURE",

    FINANCIAL_INFORMATION_REQUEST: "FINANCIAL_INFORMATION_REQUEST",
    FINANCIAL_INFORMATION_FAILURE: "FINANCIAL_INFORMATION_FAILURE",

    FINANCIAL_INFORMATION_BACK_REQUEST: "FINANCIAL_INFORMATION_BACK_REQUEST",
    FINANCIAL_INFORMATION_BACK_FAILURE: "FINANCIAL_INFORMATION_BACK_FAILURE",

    IDTYPE_AND_NUMBER_REQUEST: 'IDTYPE_AND_NUMBER_REQUEST',
    IDTYPE_AND_NUMBER_SUCCESS: 'IDTYPE_AND_NUMBER_SUCCESS',
    IDTYPE_AND_NUMBER_FAILURE: 'IDTYPE_AND_NUMBER_FAILURE',

    GUEST_PAYMENT_REGISTRATION_REQUEST: 'GUEST_PAYMENT_REGISTRATION_REQUEST',
    GUEST_PAYMENT_REGISTRATION_SUCCESS: 'GUEST_PAYMENT_REGISTRATION_SUCCESS',
    GUEST_PAYMENT_REGISTRATION_FAILURE: 'GUEST_PAYMENT_REGISTRATION_FAILURE',

    CONFIRMATION_SUMMARY_REQUEST: "CONFIRMATION_SUMMARY_REQUEST",
    CONFIRMATION_SUMMARY_RESPONSE: "CONFIRMATION_SUMMARY_RESPONSE",
    CONFIRMATION_SUMMARY_ERROR: "CONFIRMATION_SUMMARY_ERROR",

    CONFIRMATION_SUMMARY_NAVIGATION_REQUEST: "CONFIRMATION_SUMMARY_NAVIGATION_REQUEST",
    CONFIRMATION_SUMMARY_NAVIGATION_RESPONSE: "CONFIRMATION_SUMMARY_NAVIGATION_RESPONSE",
    CONFIRMATION_SUMMARY_NAVIGATION_ERROR: "CONFIRMATION_SUMMARY_NAVIGATION_ERROR",

    SEND_EMAIL_CODE_REQUEST: "EMAIL_CODE_REQUEST",
    SEND_EMAIL_CODE_RESPONSE: "EMAIL_CODE_RESPONSE",
    SEND_EMAIL_CODE_ERROR: "EMAIL_CODE_ERROR",

    EMAIL_CODE_VALIDATION_REQUEST: "EMAIL_CODE_VALIDATION_REQUEST",
    EMAIL_CODE_VALIDATION_RESPONSE: "EMAIL_CODE_VALIDATION_RESPONSE",
    EMAIL_CODE_VALIDATION_ERROR: "EMAIL_CODE_VALIDATION_ERROR",

    PROFILE_CREATE_REQUEST: "PROFILE_CREATE_REQUEST",
    PROFILE_CREATE_RESPONSE: "PROFILE_CREATE_RESPONSE",
    PROFILE_CREATE_ERROR: "PROFILE_CREATE_ERROR",

    TEXT_OPTIN_REQUEST: "TEXT_OPTIN_REQUEST",
    TEXT_OPTIN_RESPONSE: "TEXT_OPTIN_RESPONSE",
    TEXT_OPTIN_FAILURE: "TEXT_OPTIN_FAILURE",

    TEXT_OPTOUT_REQUEST: "TEXT_OPTOUT_REQUEST",
    TEXT_OPTOUT_ERROR: "TEXT_OPTOUT_ERROR",

    WELCOME_NEXT_REQUEST: "WELCOME_NEXT_REQUEST",
    WELCOME_NEXT_FAILURE: "WELCOME_NEXT_FAILURE",

    CONFIRM_PHONE_CODE_REQUEST: "CONFIRM_PHONE_CODE_REQUEST",
    CONFIRM_PHONE_CODE_RESPONSE: "CONFIRM_PHONE_CODE_RESPONSE",
    CONFIRM_PHONE_CODE_ERROR: "CONFIRM_PHONE_CODE_ERROR",
    SET_BUSY: "SET_BUSY", 

    SET_MARKETING_COOKIES: "SET_MARKETING_COOKIES",
    
    POPULATE_REGISTRATION_DATA: "POPULATE_REGISTRATION_DATA",

    REGISTRATION_LOGIN_SUCCESS : "REGISTRATION_LOGIN_SUCCESS",

    RE_SEND_EMAIL_CODE_REQUEST: "RE_SEND_EMAIL_CODE_REQUEST",
    RE_SEND_EMAIL_CODE_RESPONSE: "RE_SEND_EMAIL_CODE_RESPONSE",
    RE_SEND_EMAIL_CODE_ERROR: "RE_SEND_EMAIL_CODE_ERROR",

    SIGNUP_EMAIL_VALIDATION_BACK_REQUEST: "SIGNUP_EMAIL_VALIDATION_BACK_REQUEST",
    SIGNUP_EMAIL_VALIDATION_BACK_FAILURE: "SIGNUP_EMAIL_VALIDATION_BACK_FAILURE",

    SEND_EMPTY_EMAIL_ERROR : "SEND_EMPTY_EMAIL_ERROR",

};



// WEBPACK FOOTER //
// ./src/_constants/registration.constants.js